import { Menu, MenuItem } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import './SidebarItem.css';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { getBoardInfo } from '../../Utils/authentication-access';

const ITEM_HEIGHT = 48;

//INFO: boards are currently named as spaces
const BoardInfo = ({
  board,
  openBoard,
  renameBoard,
  deleteBoard,
  ParentName,
  DuplicateBoard,
  childLength,
  menuOptionsClose,
  activeBoard,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const boardOptionOpen = Boolean(anchorEl);
  const boardData = getBoardInfo();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseboardOptions = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    handleCloseboardOptions();
  }, [menuOptionsClose]);

  const isActive = activeBoard && activeBoard.classId == board.meta.classId;

  return (
    <>
      <div className={isActive ? 'enableBoard active' : 'enableBoard'}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            flex: 1,
            padding: '0.9em 22px 0.9em 36px',
          }}
          onClick={() => {
            openBoard(board);
          }}
        >
          <div className="boardCircleContainer" style={{ background: `${board.color}` }}></div>
          <p>{board.name}</p>
        </div>
        <div>
          <MoreHorizIcon
            fontSize="medium"
            style={{ color: 'rgba(0,0,0,0.6', cursor: 'pointer', marginRight: '22px' }}
            onClick={handleClick}
          />
          <Menu
            id={board.name}
            anchorEl={anchorEl}
            keepMounted
            open={boardOptionOpen}
            onClose={handleCloseboardOptions}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: '160px',
              },
            }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            getContentAnchorEl={null}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <MenuItem className="textColor" onClick={() => renameBoard({ board, ParentName })}>
              Rename
            </MenuItem>
            <MenuItem
              className="textColor"
              disabled={childLength === 1 || board.meta.classId === boardData.classId}
              onClick={() => deleteBoard(board)}
            >
              Delete
            </MenuItem>
            <MenuItem className="textColor" onClick={() => DuplicateBoard({ board, childLength })}>
              Duplicate
            </MenuItem>
          </Menu>
        </div>
      </div>
    </>
  );
};

export default BoardInfo;
